/** Hover tooltip with arrow. Wraps React Aria Tooltip. */
import {
  Tooltip as AriaTooltip,
  TooltipTrigger as AriaTooltipTrigger,
  OverlayArrow,
  type TooltipProps as AriaTooltipProps,
} from 'react-aria-components';
import { cn } from '@/foundation/utils/cn';
import { useInterfacePortalContainer } from '@/foundation/ui/InterfacePortalContext';

interface TooltipProps extends Omit<AriaTooltipProps, 'children'> {
  className?: string;
  children?: React.ReactNode;
}

export function Tooltip({ className, children, ...props }: TooltipProps) {
  const portalContainer = useInterfacePortalContainer();

  return (
    <AriaTooltip
      UNSTABLE_portalContainer={portalContainer ?? undefined}
      offset={8}
      className={cn(
        'bg-[var(--f-fg)] text-[var(--f-fg-on-accent)] rounded-lg px-3 py-1.5 text-sm shadow-lg',
        'data-[entering]:animate-fade-in data-[exiting]:animate-fade-out',
        className
      )}
      {...props}
    >
      <OverlayArrow>
        <svg
          width={8}
          height={8}
          viewBox="0 0 8 8"
          className="fill-[var(--f-fg)] data-[placement=bottom]:rotate-180 data-[placement=left]:-rotate-90 data-[placement=right]:rotate-90"
        >
          <path d="M0 0 L4 4 L8 0" />
        </svg>
      </OverlayArrow>
      {children}
    </AriaTooltip>
  );
}

export { AriaTooltipTrigger as TooltipTrigger };
